module.exports = __webpack_public_path__ + "static/media/vw-bg-smoke.b7134eea.png";